var map = {
	"./decidim/avatar-multiuser.png": 2010,
	"./decidim/brands/facebook.svg": 13436,
	"./decidim/brands/google.svg": 65077,
	"./decidim/brands/twitter-x.svg": 26934,
	"./decidim/cc-badge.png": 4228,
	"./decidim/decidim-logo.svg": 58216,
	"./decidim/default-avatar.svg": 41648,
	"./decidim/gamification/badges/decidim_gamification_badges_followers.svg": 61804,
	"./decidim/icons.svg": 3787,
	"./decidim/pattern.png": 172,
	"./decidim/placeholder-card-g.svg": 38505,
	"./decidim/placeholder-card-l.svg": 63170,
	"./decidim/placeholder.jpg": 80513,
	"./decidim/remixicon.symbol.svg": 6661,
	"./decidim/vendor/social-share-button/douban.svg": 13172,
	"./decidim/vendor/social-share-button/email.svg": 50001,
	"./decidim/vendor/social-share-button/facebook.svg": 20823,
	"./decidim/vendor/social-share-button/google_bookmark.svg": 95881,
	"./decidim/vendor/social-share-button/hacker_news.svg": 10721,
	"./decidim/vendor/social-share-button/linkedin.svg": 73393,
	"./decidim/vendor/social-share-button/odnoklassniki.svg": 1042,
	"./decidim/vendor/social-share-button/pinterest.svg": 85543,
	"./decidim/vendor/social-share-button/reddit.svg": 17547,
	"./decidim/vendor/social-share-button/telegram.svg": 44526,
	"./decidim/vendor/social-share-button/tumblr.svg": 83405,
	"./decidim/vendor/social-share-button/twitter.svg": 42112,
	"./decidim/vendor/social-share-button/vkontakte.svg": 43694,
	"./decidim/vendor/social-share-button/wechat.svg": 66825,
	"./decidim/vendor/social-share-button/whatsapp.svg": 28305,
	"./decidim/vendor/social-share-button/x.svg": 42649,
	"./decidim/vendor/social-share-button/xing.svg": 9015
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 91613;